import React from "react";
import styles from "./Button.module.css";

function Button(props) {
  return (
    <button 
      className={styles.btn + ' ' + styles[props.type] + ' ' + styles[props.fillStyle] + ' ' + (props.invert ? styles.invert : '') + ' ft-14 ' + props.className} 
      onClick={props.onClick}
      style={{...props.style}}
      disabled={props.disabled}
      data-testid={props['data-testid']}
      >
      {props.children}
    </button>
  );
}

export default Button;